module.exports = __webpack_public_path__ + "img/milk.2a16053c.png";